module.exports = __webpack_public_path__ + "img/7guang-logo.7c7b7908.svg";